import React from 'react';
import Helmet from 'react-helmet';

const Meta = props => {

  const data = {
    title: props.title || "Create and customize fast and easy contracts free",
    description: props.description || "Create and customize fast and easy contracts free",
    type: props.type || "website",
    url: props.url || "https://contracts.ph",
    image: props.image || "https://contracts.ph/static/images/og-default-logo.png"
  }

  return (
    <Helmet
      title={data.title}
      meta={
        [
          {"name": "description", "content": data.description},
          {property: "og:title", "content": data.title}
        ]
      }
    />
  )
}

export default Meta;


// WEBPACK FOOTER //
// ./src/model/Meta.js